__turbopack_context__.v({
  "className": "bitter_78b28cb1-module__ZA4PUG__className",
  "variable": "bitter_78b28cb1-module__ZA4PUG__variable",
});
